import styles from './index.module.scss';
import noData from './images/noData.png';

const Feeds = () => {
  return (
    <div className={styles.feeds}>
      <img src={noData} />
      <div className={styles.tips}>
        Upload the nice photos or videos you&apos;ve taken recently?
      </div>
    </div>
  );
};

export default Feeds;
